import { Injectable } from "@angular/core";
import { DataStore } from "../shared/models/DataStore";

@Injectable()
export class LogStore extends DataStore {
    constructor() {
        super();
    }

    public initializeStore() {
        this.set('log', null);
    }
}
